
import Splide from '@splidejs/splide';

export const voiceSlider = () => {
  const voiceSlider = document.querySelector('.js-voice-slider');
  if (!voiceSlider) return;

  const prevButton = document.querySelector('.js-voice-slider-prev');
  const nextButton = document.querySelector('.js-voice-slider-next');

  const splide = new Splide(voiceSlider, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: '4.4rem',
    arrows: false,
    classes: {
      pagination: 'voice-slider__pagination',
      page: 'voice-slider__pagination-page',
    },
    breakpoints: {
      768: {
        gap: '2rem'
      }
    }
  }).mount();

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      splide.go('<');
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      splide.go('>');
    });
  }
};

export default voiceSlider;
